import React from "react";
import { OrdersTable } from "../../../components";

const Orders = () => {
  return (
    <>
      <h2>Orders</h2>
      <OrdersTable />
    </>
  );
};

export default Orders;
